module.exports = __webpack_public_path__ + "static/media/waze.fc3ac927.svg";